import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChart = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 3.25a.75.75 0 0 0-.75.75v17c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75h-5a.75.75 0 0 0-.75.75v4.25h-4.5V4A.75.75 0 0 0 9 3.25zm10.25 9.5h-4.5v7.5h4.5zm1.5 7.5h3.5V7.75h-3.5v12.5M8.25 12v8.25h-3.5V4.75h3.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChart;
